// 화면2 — 작업자 검토·승인 더미 데이터

// 담당 작업자 정보
export const worker = {
  nameKey: 'pages.modulec.worker.name',
  shiftKey: 'pages.modulec.worker.shift',
  roleKey: 'pages.modulec.worker.role',
  employeeId: 'EMP-2043',
};

